export const SET_STRATEGIES = 'setStrategies'
export const SET_STRATEGY = 'setStrategy'
export const SET_SERVER_DATA = 'setServerData'
export const SET_GROUPS = 'setGroups'
